<template>
    <tr :class="`inner-td ${isComplete ? '' : 'incomplete'}`">
        <td>
            <multiselect
                v-model="type"
                :options="types"
                :close-on-select="true"
                :show-labels="false"
                :hide-selected="true"
                :custom-label="t => `${t.libelle}`"
                placeholder="Type de support"
            >
                <template
                    slot="option"
                    slot-scope="props"
                >
                    {{ props.option.libelle }}
                </template>
            </multiselect>
            <p v-if="!type" class="field-incomplete">
                Renseignez un type de support
            </p>
        </td>
        <td>
            <v-text-field
                v-model="hauteur"
                :hide-details="true"
                suffix="m"
                type="number"
                class="centered-input"
                color="#eb5c2e"
            />
            <p v-if="!hauteur" class="field-incomplete">
                Renseignez une hauteur
            </p>
        </td>
        <td>
            <v-text-field
                v-model="largeur"
                :hide-details="true"
                suffix="m"
                type="number"
                min="0"
                class="centered-input"
                color="#eb5c2e"
            />
            <p v-if="!largeur" class="field-incomplete">
                Renseignez une largeur
            </p>
        </td>
        <td>
            <v-text-field
                v-model="faces"
                :hide-details="true"
                suffix="faces"
                type="number"
                min="0"
                class="centered-input"
                color="#eb5c2e"
            />
            <p v-if="!faces" class="field-incomplete">
                Renseignez un nombre de faces
            </p>
        </td>
        <td>
            <template v-if="type">
                <template v-if="type.code === 'enseigne'">
                    <v-checkbox
                        v-model="scelle"
                        :hide-details="true"
                        label="Support scellé au sol"
                        color="#eb5c2e"
                    />
                </template>
                <template v-else>
                    <v-checkbox
                        v-model="numerique"
                        :hide-details="true"
                        label="Support numérique"
                        color="#eb5c2e"
                    />
                </template>
            </template>
        </td>
        <td>
            <v-btn
                color="red"
                @click="remove()"
            >
                <v-icon color="white">
                    highlight_off
                </v-icon>
            </v-btn>
        </td>
    </tr>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'SupportLine',
    mixins: [],
    props: {
        guid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            type: null,
            hauteur: null,
            largeur: null,
            faces: null,
            numerique: null,
            scelle: null,
            isComplete: false,
        };
    },
    computed: {
        ...mapState('support', ['supports']),
        ...mapState('type', ['types']),
    },
    watch: {
        type(val) {
            this.supports[this.guid].type = val;
            this.numerique = false;
            this.scelle = false;
            this.updateCompleteStatus();
        },
        hauteur(val) {
            this.supports[this.guid].hauteur = val;
            this.updateCompleteStatus();
        },
        largeur(val) {
            this.supports[this.guid].largeur = val;
            this.updateCompleteStatus();
        },
        faces(val) {
            this.supports[this.guid].faces = val;
            this.updateCompleteStatus();
        },
        numerique(val) {
            this.supports[this.guid].numerique = val;
            this.updateCompleteStatus();
        },
        scelle(val) {
            this.supports[this.guid].scelle = val;
            this.updateCompleteStatus();
        },
    },
    created() {
        this.type = this.supports[this.guid].type;
        this.hauteur = this.supports[this.guid].hauteur;
        this.largeur = this.supports[this.guid].largeur;
        this.faces = this.supports[this.guid].faces;
        this.numerique = this.supports[this.guid].numerique;
        this.scelle = this.supports[this.guid].scelle;
    },
    methods: {
        ...mapActions('support', ['removeSupport']),
        updateCompleteStatus() {
            const hasType = null !== this.type;
            const hasHauteur = null !== this.hauteur;
            const hasLargeur = null !== this.largeur;
            const hasFaces = null !== this.faces;

            this.isComplete = hasType && hasHauteur && hasLargeur && hasFaces;
            this.$emit('update');
        },
        remove() {
            this.removeSupport(this.supports[this.guid]);
            this.updateCompleteStatus();
        },
    },
}
</script>

<style scoped>
.inner-td > td {
    padding-left: 2em;
    padding-right: 2em;
}

.centered-input >>> input {
    text-align: right;
}

.incomplete {
    box-shadow: inset 0 0 0 2px rgba(255, 0, 0, 1);
}

.field-incomplete {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/SupportLine.vue